
import { computed, defineComponent, PropType, toRefs, provide, readonly, reactive, inject } from "vue";
import UfTreeNode from "./TreeNode.vue";

export interface PlaceTreeNode {
  id: string;
  level: string;
  lists: PlaceTreeNode[];
  pid: string;
  place: string;
  ppath: string;
  qrcode: string;
  qrcode_encode: string;
  rfid: string;
  sort: string;
  true_place_name: string;
}

export interface UfTreeType {
  checkedList: PlaceTreeNode[];
  getCurrentNode: () => PlaceTreeNode | PlaceTreeNode[];
}

export default defineComponent({
  name: "UfTree",
  components: {
    UfTreeNode
  },
  props: {
    data: {
      type: Array as PropType<PlaceTreeNode[]>,
      required: true
    }
  },
  setup(props) {
    // 获取数据
    const { data } = toRefs(props);

    const multiple = inject<boolean>("multiple");

    const innerData = computed(() => data.value);
    // 默认展开的值
    const expandedKeys = reactive<string[]>([]);
    const updateExpandedKeys = (keys: string) => {
      const idx = expandedKeys.findIndex(_keys => _keys === keys);
      if (idx != -1) {
        expandedKeys.splice(idx, 1);
        return;
      }
      expandedKeys.push(keys);
      return;
    };
    provide("expandedKeys", readonly(expandedKeys));
    provide("updateExpandedKeys", updateExpandedKeys);
    // 选中的值
    const checked = reactive<PlaceTreeNode | {}>({});
    // 多选的话
    const checkedList = reactive<PlaceTreeNode[]>([]);

    const updateChecked = (data: PlaceTreeNode) => {
      if (multiple) {
        const idx = checkedList.findIndex(checked => checked === data);
        if (idx != -1) {
          checkedList.splice(idx, 1);
          return;
        }
        checkedList.push(data);
        return;
      }
      Object.assign(checked, data);
    };
    provide("checked", readonly(checked));
    provide("checkedList", checkedList);

    provide("updateChecked", updateChecked);
    // 返回值
    const getCurrentNode = () => {
      if (multiple) {
        return checkedList;
      }
      return checked;
    };
    return {
      innerData,
      checked,
      checkedList,
      getCurrentNode
    };
  }
});
